import React, {useState, useEffect} from "react";
import Navigation from "../partials/Navigation";
import AddNewUser from "../partials/admin/AddNewUser";
import AddNewCompany from "../partials/admin/AddNewCompany";
import HorizontalNav from "../partials/Dashboard/HorizontalNav";
import ImportUsers from "../partials/admin/ImportUsers";
import { useSelector } from "react-redux";
import Tab from 'react-bootstrap/Tab';
import Nav from 'react-bootstrap/Nav';
import ClearCache from "../partials/admin/ClearCache";
import configVars from "../config";
import { getWithExpiry, setWithExpiry } from "../common";

const SustainAdmin = () => {

	const isAdmin = useSelector((state) => state.userdata.isAdmin);
  	const [key, setKey] = useState( 'user' );
	  const [allMemberships, setAllMemberships] = useState([]);
	  const [loadingMemberships, setLoadingMemberships] = useState(false);

	useEffect(() => {
		getMembershipPlans();
	}, []);

	const getMembershipPlans = async () => {
        const savedPlans = getWithExpiry("sy_all_membership_plans");
    
        if (savedPlans) {
          setAllMemberships(savedPlans);
        } else {
          setLoadingMemberships(true);
    
          const response = await fetch(
            `${configVars.apiUrl}sustainchange/v1/getallmembershipplans`,
            {
              method: "GET",
              headers: {
                Authorization: `Basic ${configVars.auth}`,
              },
            }
          );
    
          const plansResponse = await response.json();
    
          if (plansResponse) {
            if (plansResponse.success === true) {
              setAllMemberships(plansResponse.data);
              setWithExpiry("sy_all_membership_plans", plansResponse.data);
            }
          }
    
          setLoadingMemberships(false);
        }
    };


  return (
    <div className="main-wrapper">
      <Navigation />

      <div className="page-content-wrap">
        <HorizontalNav title="SustainYou Admin" />

        <div className="pt-5 pt-lg-0 page-content-inner">

			{isAdmin &&
				<div className="col-12 mt-5 mt-lg-6 px-4 pt-3" style={{ maxWidth: '1000px' }}>
					<Tab.Container id="admin-left-tabs" defaultActiveKey="user" onSelect={ (k) => setKey(k)}>
						<div className="row">
							<div className="col-12 col-lg-3">
								<Nav className="flex-column bg-white rounded-3 h-100">
									<Nav.Item className="border-bottom">
										<Nav.Link className={`${ key === 'user' ? 'bg-primary text-white' : ''} rounded-top`} eventKey="user">Add user</Nav.Link>
									</Nav.Item>
									<Nav.Item className="border-bottom">
										<Nav.Link className={`${ key === 'company' ? 'bg-primary text-white' : ''}`} eventKey="company">Add Organization</Nav.Link>
									</Nav.Item>
									<Nav.Item className="border-bottom">
										<Nav.Link className={`${ key === 'import-users' ? 'bg-primary text-white' : ''}`} eventKey="import-users">Import users</Nav.Link>
									</Nav.Item>
									<Nav.Item className="border-bottom">
										<Nav.Link className={`${ key === 'cache' ? 'bg-primary text-white' : ''}`} eventKey="cache">Cache</Nav.Link>
									</Nav.Item>
								</Nav>
							</div>
							<div className="col-12 col-lg-9">
								<div className="bg-white rounded-3 p-3">
									<Tab.Content>
										<Tab.Pane eventKey="user">
											<AddNewUser allMemberships={allMemberships} loadingMemberships={loadingMemberships} />
										</Tab.Pane>
										<Tab.Pane eventKey="company">
											<AddNewCompany allMemberships={allMemberships} loadingMemberships={loadingMemberships} />
										</Tab.Pane>
										<Tab.Pane eventKey="import-users">
											<ImportUsers allMemberships={allMemberships} loadingMemberships={loadingMemberships} />
										</Tab.Pane>
										<Tab.Pane eventKey="cache">
											<ClearCache />
										</Tab.Pane>
									</Tab.Content>
								</div>
							</div>
						</div>
					</Tab.Container>
				</div>
			}

        </div>
      </div>
    </div>
  );
};

export default SustainAdmin;
